module.exports = __webpack_public_path__ + "img/banner.70ca46a9.jpg";